export default __webpack_public_path__ + "static/media/ic_down_caret.68de3be0.svg";